export default __webpack_public_path__ + "static/media/BeltsImg.17815999.jpg";